import React from 'react';
import './RequestDemo.css'
import { Modal } from 'antd';
import { clearAll, setCookie } from '../../../shared/helpers';
import { resetCompanyProfileDetails, resetUserProfile, updateUserInfo } from '../../../redux/actions';
import { Auth } from '../../../config/aws-exports';
import { useDispatch } from "react-redux";


const RequestDemo = ({ modal2Open }) => {
    const dispatch = useDispatch();

    const onLogOut = async () => {
        try {
            await Auth.signOut();
            setCookie("token", "");
            setCookie("RememberMe", "false");
            setCookie('impersonationid', '');
            setCookie('finishProfile', '');
            clearAll();
            dispatch(updateUserInfo(null))
            // history.push("/home");
            // window.location.replace("/employer/login");
            window.location.replace("/login");
            dispatch(resetUserProfile());
            dispatch(resetCompanyProfileDetails());
            // props.hide();
            localStorage.removeItem("userProfile");
            localStorage.removeItem("redirectUrl");
            // props.changeStage("");
        } catch (error) { }
    };

    // setTimeout(onLogOut, 10000);

    return (
        <div>
            <Modal
                centered
                visible={modal2Open}
                footer={null}
                width={800}
                closable={false}
            >
                <h1 className='Request-demo-H1'>Welcome to SkillGigs!</h1>

                <p className='Request-demo-P-Tag'>Thank you for signing up. Our representative will be in touch shortly to help you get started and ensure the system is set up to meet your specific needs. </p>
                <p className='Request-demo-P-Tag'>In the meantime, if you have any questions, please email us at <span className='Request_Demo_EmailHighLights' >sales@skillgigs.com</span>. </p>
                <p className='Request-demo-P-Tag'>We look forward to supporting your hiring success! </p>
                <p className='Request-demo-P-Tag'>Best regards,</p>
                <p className='Request-demo-P-Tag'>The SkillGigs Team</p>
            </Modal>
        </div>
    );
};

export default RequestDemo;

